/** Shared SweetAlert2 Bootstrap styling presets. */

export const SWAL_BASE = { buttonsStyling: false };

export const SWAL_CLASSES = {
    ok: {
        confirmButton: "btn btn-primary"
    },
    okLight: {
        confirmButton: "btn btn-light",
    },
    dangerOk: {
        confirmButton: "btn btn-danger",
    },
    confirmCancel: {
        confirmButton: "btn btn-primary me-2",
        cancelButton: "btn btn-outline-secondary",
    },
    confirmCancelLight: {
        confirmButton: "btn btn-primary me-2",
        cancelButton: "btn btn-light",
    },
    destructive: {
        confirmButton: "btn btn-danger me-2",
        cancelButton: "btn btn-outline-secondary",
    },
    precheck: {
        confirmButton: "btn btn-danger",
        denyButton: "btn btn-light mx-2",
        cancelButton: "btn btn-outline-secondary",
    },
    trial: {
        confirmButton: "btn btn-primary me-2",
        denyButton: "btn btn-outline-secondary",
    },
    denyCancel: {
        confirmButton: "btn btn-lg btn-primary me-2",
        denyButton: "btn btn-lg btn-outline-secondary",
    },
    destructiveDeny: {
        confirmButton: "btn btn-lg btn-danger me-2",
        denyButton: "btn btn-lg btn-outline-secondary",
    },
};
